import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  Toolbar,
  IconButton,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import KakaoLoginButton from '../components/KakaoLoginButton';

const RegisterPage: React.FC = () => {
  const [error, setError] = useState('');
  const [loading] = useState(false);
  
  const navigate = useNavigate();

  const handleKakaoLoginError = (errorMessage: string) => {
    setError(errorMessage);
  };

  return (
    <Box>
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" component="div">
            회원가입
          </Typography>
        </Toolbar>
      </AppBar>

      <Container component="main" maxWidth="sm" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h4" component="h1" gutterBottom color="primary">
              Silver Connect
            </Typography>
            <Typography variant="h6" color="text.secondary">
              새로운 인연의 시작
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
              회원가입 방식을 선택해주세요
            </Typography>

            {/* 일반 회원가입 */}
            <Button
              variant="contained"
              fullWidth
              onClick={() => navigate('/register/normal')}
              sx={{ 
                py: 2, 
                mb: 3,
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                }
              }}
            >
              이메일로 회원가입
            </Button>

            {/* 구분선 */}
            <Box sx={{ display: 'flex', alignItems: 'center', my: 3 }}>
              <Box sx={{ flex: 1, height: 1, backgroundColor: 'divider' }} />
              <Typography variant="body2" sx={{ px: 2, color: 'text.secondary' }}>
                또는
              </Typography>
              <Box sx={{ flex: 1, height: 1, backgroundColor: 'divider' }} />
            </Box>

            {/* 카카오 회원가입 */}
            <KakaoLoginButton
              onError={handleKakaoLoginError}
              disabled={loading}
              fullWidth
              variant="outlined"
              sx={{ mt: 0, mb: 3, py: 2 }}
            >
              카카오로 간편가입
            </KakaoLoginButton>

            <Alert severity="info" sx={{ mt: 3 }}>
              <Typography variant="body2">
                • 회원가입 후 관리자 승인을 거쳐 정식 회원이 됩니다<br />
                • 가입 승인 시 10개의 하트가 지급됩니다<br />
                • 매주 새로운 큐피트 카드를 받아보실 수 있습니다<br />
                • 50세~70세만 가입 가능합니다
              </Typography>
            </Alert>

            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Typography variant="body2">
                이미 계정이 있으신가요?{' '}
                <Button
                  variant="text"
                  onClick={() => navigate('/login')}
                  sx={{ color: 'primary.main', p: 0, minWidth: 'auto' }}
                >
                  로그인하기
                </Button>
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default RegisterPage;